import { render, staticRenderFns } from "./EditUserFullName.vue?vue&type=template&id=7059f6c8&scoped=true&"
import script from "./EditUserFullName.vue?vue&type=script&lang=js&"
export * from "./EditUserFullName.vue?vue&type=script&lang=js&"
import style0 from "./EditUserFullName.vue?vue&type=style&index=0&id=7059f6c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7059f6c8",
  null
  
)

component.options.__file = "EditUserFullName.vue"
export default component.exports